






































import { Component, Vue, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';
import store from '@/store';

@Component({
  components: {
    Loading,
  },
})
export default class CenterList extends Vue {
  @Prop({ required: false, default: false })
  public adminVersion = false;

  get centersQuery() {
    return gql`
      query Centers {
        centers {
          id
          centerCode
          name
        }
      }
    `;
  }

  public onCenterClicked(center: any) {
    this.$emit('centerSelected', center.id, center.centerCode);
  }

  public centerImage(center: any) {
    try {
      return require(`@/assets/centers/${center.centerCode}/logo.png`);
    } catch (e) {
      return null;
    }
  }
}
